import React from "react";

const StatsCard = ({
  icon,
  label = "Power Score",
  score = 0,
  total = 100,
  percentage = "+0",
  trendIcon,
  chartIcon,
  scoreColor = "#e6ecf1",
  percentageColor = "#5ce0a0",
}) => {
  return (
    <div className="col-md-6 col-lg-6 col-xl-4">
      <div className="all-stats-card">
        <div className="d-flex align-items-center gap-3">
          <span
            style={{
              width: "46px",
              height: "46px",
              borderRadius: "50%",
              backgroundColor: "#1b2c3a",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={icon} alt="" />
          </span>
          <div className="d-flex flex-column" style={{ gap: "1px" }}>
            <p
              className="text-body-b3"
              style={{ color: "#b5bbc0", margin: "0" }}
            >
              {label}
            </p>
            <div
              className="text-heading-h3"
              style={{ color: scoreColor, margin: "0" }}
            >
              {score}/{total}
            </div>
          </div>
        </div>
        <div
          className="d-flex flex-column align-items-end"
          style={{ gap: "12px" }}
        >
          <img
            src={trendIcon}
            alt=""
            style={{ width: "32px", height: "9.625625610351562px" }}
          />
          <div className="d-flex align-items-center gap-2">
            <img src={chartIcon} alt="" />
            <span
              className="text-caption-c2"
              style={{ color: percentageColor }}
            >
              {percentage}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
